/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Item_GroupInputs */

const en_task_flow_item_group = /** @type {(inputs: Task_Flow_Item_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group`)
};

const pt_br2_task_flow_item_group = /** @type {(inputs: Task_Flow_Item_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo`)
};

/**
* | output |
* | --- |
* | "Group" |
*
* @param {Task_Flow_Item_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_item_group = /** @type {((inputs?: Task_Flow_Item_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Item_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_item_group(inputs)
	return pt_br2_task_flow_item_group(inputs)
});